import { t } from 'i18next';
import type { ICalEventData } from 'ical-generator';
import ICalGenerator from 'ical-generator';
import moment from 'moment';
import type { RoadmapEvent } from '../interfaces/event';
import { saveAsFile } from './fileUtils';

export const saveReminderFile = (roadmapItem: RoadmapEvent, translatedEventType: string, translatedTopicName: string, clientName: string) => {
    const start = moment(roadmapItem.reminderDate).hours(10).minutes(0).seconds(0);
    const amount = roadmapItem.amount ? `<p>${t('amountLabel')}: ${roadmapItem.amount}</p>` : '';
    const event: ICalEventData = {
        start,
        end: moment(start).add(1, 'hour').toDate(),
        summary: t('followUpClientRoadmap'),
        description: {
            plain: '',
            html: `
            <p><b>${t('autoGeneratedReminder')}</b></p>
            <p>${t('clientLabel')}: ${clientName}</p>
            <p>${t('topicLabel')}: ${translatedTopicName}</p>
            <p>${t('descriptionLabel')}: ${translatedEventType} - <b>${roadmapItem.name}</b></p>
            ${amount}
            <p>${t('dueDateLabel')}: ${moment(roadmapItem.dueDate).format('DD.MM.YYYY')}</p>
            <p>${t('creationDateLabel')}: ${moment(roadmapItem.createdAt).format('DD.MM.YYYY')}</p>`,
        },
    };
    const reminder = ICalGenerator({ events: [event] });
    saveAsFile(reminder.toString(), t('reminderFileName'), 'text/plain;charset=utf-8');
};
